// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeReasonAuthShared = {
  activityMemberInactive: "{resource}のアクティビティメンバーは無効です",
  activityRoleRequired: "現在のアカウントには必要な{resource}アクティビティロールがありません",
  adminAccessRequired: "現在のアカウントには{resource}管理者権限がありません",
  appSessionRequired: "現在のリクエストには{resource}アプリセッションが必要です",
  applicationAccessDenied: "現在のアカウントでは{resource}アプリケーションにアクセスできません",
  applicationContextInvalid: "{resource}アプリケーションコンテキストが無効です",
  authorizationPromptInvalid: "{resource}の認証 prompt は許可されていません",
  avatarMustBeImage: "{resource}のアバターは画像である必要があります",
  candidateAccountExpired: "{resource}の受験者アカウントは期限切れです",
  invalidAuthMode: "{resource}の認証モードが無効です",
  invalidReturnPath: "{resource}の戻り先パスは有効なアプリ内相対パスである必要があります",
  invalidSsoBffResponse: "{resource}の SSO BFF 応答が契約に一致しません",
  memberAccessRequired: "現在のアカウントには{resource}メンバーアクセス権がありません",
  memberInactive: "{resource}メンバーは無効です",
  missingRefreshToken: "{resource}のリフレッシュトークンがありません",
  oidcRequestFailed: "{resource}の OIDC/BFF リクエストに失敗しました",
  oidcTransactionMissing: "{resource}の OIDC コールバックに認証トランザクションがありません",
  redirectUriNotConfigured: "{resource}の OIDC callback redirect URI が設定されていません",
  sessionInvalidated: "{resource}セッションは無効化されました。再ログインしてください",
  siteMaintenance: "{resource}サイトはメンテナンス中です",
  ssoBffNotConfigured: "{resource}の SSO BFF client 設定が不完全です",
  ssoBootstrapFailed: "{resource}の SSO 初期化に失敗しました",
  teacherAccessRequired: "現在のアカウントには{resource}教師権限がありません",
  userInactiveOrNotFound: "{resource}ユーザーは無効、または見つかりません",
} as const;
